import React, { useCallback } from 'react';
import { IconBoldPlus } from 'design-system/icons/IconBoldPlus';
import { IconMoneyCheckPenSolid } from 'design-system/icons/IconMoneyCheckPenSolid';
import { SettingsItem } from 'design-system/SettingsItem';
import Links from 'utils/links';
const QuotesModalContent = ({ hideModal, url, onStartNewQuote, }) => {
    const handleSeeLatestQuote = useCallback(() => {
        hideModal(() => Links.openLink(url));
    }, [hideModal, url]);
    const handleStartNewQuote = useCallback(() => {
        hideModal(onStartNewQuote);
    }, [hideModal, onStartNewQuote]);
    return (<>
      <SettingsItem title="See latest quote" onPress={handleSeeLatestQuote} icon={<IconMoneyCheckPenSolid gradientKey="darkPurple"/>}/>
      <SettingsItem title="Start a new quote" onPress={handleStartNewQuote} icon={<IconBoldPlus gradientKey="orange"/>}/>
    </>);
};
export default QuotesModalContent;
